module.exports = __webpack_public_path__ + "static/media/BoxPlotQ1_4.03906f1f.svg";